<template>
  <div class="Logs">
    <div class="list-search log-search">
      <div>
        <label>操作内容</label>
        <Select v-model="operate" @change="selectOperate" :getPopupContainer="(triggerNode)=>{ return triggerNode.parentNode}" style="width: 160px">
          <Option value="0">全部</Option>
          <Option value="1">登录</Option>
          <Option value="2">登出</Option>
          <Option value="3">下载License</Option>
          <Option value="4">发送License</Option>
          <Option value="5">修改密码</Option>
          <Option value="6">导出License统计表</Option>
        </Select>
      </div>
      <div>
        <label for="">操作时间</label>
        <RangePicker
          :disabled-date="disabledDate"
          :disabled-time="disabledRangeTime"
          :show-time="{ format: 'HH:mm' }"
          separator="→"
          format="YYYY-MM-DD HH:mm"
          :placeholder="['开始时间', '结束时间']"
          @change="onChange"
          @openChange="isOpen"
          :getCalendarContainer="getCalendarContainer()"
        >
          <Icon slot="suffixIcon" type="calendar" />
        </RangePicker>
      </div>
    </div>
    <div class="list-content">
      <Table
        :columns="columns"
        :rowKey="(record, index) => index"
        :data-source="dataSource"
        :loading="loading"
        :pagination="pageOpt"
        @change="handleTableChange"
      >
        <template slot="content" slot-scope="text">
          <span>{{ getContent(text) }}</span>
        </template>
      </Table>
    </div>
  </div>
</template>

<script>
import './logs.less'

import { Table, Icon, Select, DatePicker } from 'ant-design-vue'
const { Option } = Select
const { RangePicker } = DatePicker
import moment from 'moment'
import { createNamespacedHelpers } from 'vuex'
const { mapActions } = createNamespacedHelpers('logs')
// import user_service from '@/model/user_service.js'

export default {
  name: 'Logs',
  data() {
    return {
      search: {
        user: '',
        region: 'shanghai',
      },
      dataSource: [],
      columns: [
        {
          title: '操作时间',
          dataIndex: 'operateTime',
          // sorter: true
        },
        {
          title: '操作内容',
          dataIndex: 'content',
          scopedSlots: { customRender: 'content' },
        },
        {
          title: '登录时间',
          dataIndex: 'loginTime',
          scopedSlots: { customRender: 'loginTime' },
        },
        {
          title: '主机IP',
          dataIndex: 'ip',
        },
      ],
      loading: true,
      currentPage: 1,
      pageSize: 20,
      total: 0,
      operate: '0',
      startTime: '',
      endTime: '',
    }
  },
  computed: {
    pageOpt() {
      const pagination = {
        pageSizeOptions: ['5', '10', '20', '50', '100'],
        defaultPageSize: 20,
        total: this.total,
        current: this.currentPage,
        showSizeChanger: true,
        showTotal: total => `共有 ${total} 条`
      }
      return pagination
    },
  },
  created() {
    this.update()
  },
  methods: {
    ...mapActions(['getLogs']),
    getCalendarContainer() {
      return triggerNode => triggerNode.parentNode;
    },
    range(start, end) {
      const result = []
      for (let i = start; i < end; i++) {
        result.push(i)
      }
      return result
    },
    selectOperate(val) {
      this.currentPage = 1
      this.update()
    },
    disabledDate(current) {
      return current > moment().endOf('day')
    },
    disabledRangeTime(_, type) {
      let start = moment().calendar().substring(2).split(':')
      let end = moment().diff(moment(this.endTime), 'days')
      let endHours = moment().diff(moment(this.endTime), 'hours')
      let st = moment().diff(moment(this.startTime).format('YYYY-MM-DD'), 'days')
      let stHours = moment().diff(moment(this.startTime).format('YYYY-MM-DD HH'), 'hours')
      if(type === 'end'){
        if(end <=0 && endHours <= 0){
        return {
          disabledHours: () =>
          this.range(0, 24).splice(Number(start[0]) + 1, Number(24 - start[0])),
          disabledMinutes: () =>
          this.range(0, 60).splice(Number(start[1]) + 1, Number(60 - start[1])),
        }
        }else if(end <=0 ){
          return {
            disabledHours: () =>
            this.range(0, 24).splice(Number(start[0]) + 1, Number(24 - start[0])),
          }
        }else{
          return {}
        }
      }
      if (type === 'start') {
        if(stHours <= 0){
          return {
          disabledHours: () =>
            this.range(0, 24).splice(Number(start[0]) + 1, Number(24 - start[0])),
          disabledMinutes: () =>
            this.range(0, 60).splice(Number(start[1]) + 1, Number(60 - start[1])),
          }
        }else if(st <= 0){
          return {
            disabledHours: () =>
            this.range(0, 24).splice(Number(start[0]) + 1, Number(24 - start[0])),
          }
        }else{
          return {}
        }
      }
      // return {
      //   disabledHours: () =>
      //     this.range(0, 24).splice(Number(start[0]) + 1, Number(24 - start[0])),
      //   disabledMinutes: () =>
      //     this.range(0, 60).splice(Number(start[1]) + 1, Number(60 - start[1])),
      // }
    },
    handleTableChange(pagination) {
      if (pagination.pageSize !== this.pageSize) {
        this.pageSize = pagination.pageSize
        this.currentPage = 1
      } else {
        this.pageSize = pagination.pageSize
        this.currentPage = pagination.current
      }
      this.update()
    },
    onChange(value, dateString) {
      this.currentPage = 1
      this.startTime = dateString[0]
      this.endTime = dateString[1]
      if(value.length===0){
        this.update()
      }
    },
    onOk(value) {
      this.currentPage = 1
      this.update()
    },
    isOpen(val) {
      if (!val) {
        this.onOk(this.startTime)
      }
    },
    getContent(text) {
      return JSON.parse(text).cn
    },
    async update() {
      this.loading = true
      let params = {
        type: this.operate,
        startTime: this.startTime,
        endTime: this.endTime,
        pageNo: this.currentPage,
        pageSize: this.pageSize,
      }
      let res = await this.getLogs(params)
      this.loading = false
      if (res.id) {
        this.$message.error(res.msg, 1)
      } else {
        this.dataSource = res.results
        this.total = res.totalRecord
      }
    },
  },
  components: {
    Table,
    Select,
    Icon,
    Option,
    // ADatePicker: DatePicker,
    RangePicker,
  },
}
</script>
